import * as Yup from "yup";

export const CreateUserSchema = () => {
  return Yup.object().shape({
    username: Yup.string()
      .required("El usuario es requerido")
      .trim()
      .min(3, "El usuario debe tener mínimo 3 caracteres")
      .matches(
        /^[a-zA-Z0-9._-]+$/,
        "El usuario solo puede contener letras, números, punto, guion y guion bajo"
      ),

    password: Yup.string()
      .required("La contraseña es requerida")
      .min(8, "La contraseña debe tener mínimo 8 caracteres")
      .max(64, "Máximo 64 caracteres"),

    confirmPassword: Yup.string()
      .required("Confirma la contraseña")
      .oneOf([Yup.ref("password")], "Las contraseñas no coinciden"),
  });
};